import React from 'react';
import '../styles/Sidebar.scss';
import ContactForm from './ContactForm';
import initialsSVG from '../../public/images/svg/initials.svg';
import SVG from './SVG';

const Sidebar = props => (
  <aside className="Sidebar">
    <div className='inner'>
      <h1>{"Hi, I'm Zak."}</h1>
      <p>{"I'm a full stack web developer, with a background in graphic design and event production."}</p>
      <p>{"I like to make cool stuff."}</p>
      <p>{"I'd love to talk with you about your project, so shoot me an email with some details and I'll get back to you as soon as I can."}</p>
      <ContactForm {...props} />
      <p>{"Thanks for checking out my site, and I can't wait to work together!"}</p>
      <SVG file={initialsSVG} name="initials" />
    </div>
  </aside>
);

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar.js